import React, { useState } from 'react';
import { format } from 'date-fns';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './performanceSelector.module.css';

const PerformanceSelector = ({ performances, defaultPerformance, onHandleChange }) => {
  const [selectedPerformance, setSelectedPerformance] = useState(defaultPerformance);

  const onChangePerformance = (value) => {
    setSelectedPerformance(value);
    if (onHandleChange) onHandleChange(value);
  };

  return (
    <div className={`performance-selector`}>
      <Swiper spaceBetween={10} slidesPerView={'auto'}>
        {performances.map((performance, i) => {
          const displayTime = format(performance.time, 'h:mm aaa');
          const sendTime = format(performance.time, 'HH:mm'); 
          const isDisabled = performance.soldOut;
          const isSelected = selectedPerformance === sendTime;

          return (
            <SwiperSlide key={i}>
              <button
                className={`${styles.performanceSelector} ${isSelected ? styles.selected : ''}`}
                onClick={() => onChangePerformance(sendTime)} 
                disabled={isDisabled}
              >
                {displayTime}
              </button>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default PerformanceSelector;
